import { Link } from 'react-router-dom';
import { ModeToggle } from './ModeToggle';

export const Footer = () => {
  return (
    <footer>
      <div className="container mx-auto flex flex-col gap-2 px-4 py-8">
        <p className="text-center text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} HappiScreen. All rights reserved.
        </p>
        <div className="flex items-center justify-center gap-4 text-xs">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-use">Terms of Use</Link>
          <ModeToggle />
        </div>
      </div>
    </footer>
  );
};
